import { produce } from 'immer'

import { Redux } from 'types/local'
import { Enum } from 'types/enum'
import { homeActions } from './home.actions'

const { types } = homeActions

export type State = Redux.UserState['home']
export const initialState: State = {
  project: {
    list: [],
    popularList: [],
    newList: [],
    topRatedList: [],
    page: 1,
    pageSize: 20,
    isLoading: false,
    active: undefined,
    feature: undefined,
    infoVerify: undefined,
    auditVerify: undefined,
    emailVerify: undefined,
    sortby: 'rating',
    order: 'desc',
    tokenAddress: undefined,
    ownerAddress: undefined,
    total: 0,
  },
  totalParticipants: 0,
  popularSpins: [],
}
export const homeReducer = produce((state: State, action: Redux.Action) => {
  // eslint-disable-next-line default-case
  switch (action.type) {
    case types.GET_PROJECT_LIST.REQUEST:
      state.project.isLoading = true
      state.project.order = action.payload.order
      state.project.sortby = action.payload.sortby
      state.project.active = action.payload.active
      state.project.feature = action.payload.feature
      state.project.infoVerify = action.payload.infoVerify
      state.project.auditVerify = action.payload.auditVerify
      state.project.emailVerify = action.payload.emailVerify
      state.project.search = action.payload.search
      state.project.page = action.payload.page
      state.project.pageSize = action.payload.pageSize
      state.project.tokenAddress = action.payload.tokenAddress
      state.project.ownerAddress = action.payload.ownerAddress
      break
    case types.GET_PROJECT_LIST.SUCCESS:
      state.project.list = action.payload.data
      state.project.total = action.payload.meta.total
      state.project.isLoading = true
      break

    case types.GET_PROJECT_LIST.FAILED:
      state.project.isLoading = true
      break

    case types.GET_POPULAR_PROJECT_LIST.REQUEST:
      state.project.isLoading = true
      state.project.order = action.payload.order
      state.project.sortby = action.payload.sortby
      state.project.active = action.payload.active
      state.project.feature = action.payload.feature
      state.project.infoVerify = action.payload.infoVerify
      state.project.auditVerify = action.payload.auditVerify
      state.project.emailVerify = action.payload.emailVerify
      state.project.search = action.payload.search
      state.project.page = action.payload.page
      state.project.pageSize = action.payload.pageSize
      state.project.tokenAddress = action.payload.tokenAddress
      state.project.ownerAddress = action.payload.ownerAddress
      break
    case types.GET_POPULAR_PROJECT_LIST.SUCCESS:
      state.project.popularList = action.payload.data
      state.project.total = action.payload.meta.total
      state.project.isLoading = true
      break

    case types.GET_POPULAR_PROJECT_LIST.FAILED:
      state.project.isLoading = true
      break

    case types.GET_NEW_PROJECT_LIST.REQUEST:
      state.project.isLoading = true
      state.project.order = action.payload.order
      state.project.sortby = action.payload.sortby
      state.project.active = action.payload.active
      state.project.feature = action.payload.feature
      state.project.infoVerify = action.payload.infoVerify
      state.project.auditVerify = action.payload.auditVerify
      state.project.emailVerify = action.payload.emailVerify
      state.project.search = action.payload.search
      state.project.page = action.payload.page
      state.project.pageSize = action.payload.pageSize
      state.project.tokenAddress = action.payload.tokenAddress
      state.project.ownerAddress = action.payload.ownerAddress
      break
    case types.GET_NEW_PROJECT_LIST.SUCCESS:
      state.project.newList = action.payload.data
      state.project.total = action.payload.meta.total
      state.project.isLoading = true
      break

    case types.GET_NEW_PROJECT_LIST.FAILED:
      state.project.isLoading = true
      break

    case types.GET_TOP_RATED_LIST.REQUEST:
      state.project.isLoading = true
      state.project.order = action.payload.order
      state.project.sortby = action.payload.sortby
      state.project.active = action.payload.active
      state.project.feature = action.payload.feature
      state.project.infoVerify = action.payload.infoVerify
      state.project.auditVerify = action.payload.auditVerify
      state.project.emailVerify = action.payload.emailVerify
      state.project.search = action.payload.search
      state.project.page = action.payload.page
      state.project.pageSize = action.payload.pageSize
      state.project.tokenAddress = action.payload.tokenAddress
      state.project.ownerAddress = action.payload.ownerAddress
      break
    case types.GET_TOP_RATED_LIST.SUCCESS:
      console.log('action.payload', action.payload)

      state.project.topRatedList = action.payload.data
      state.project.total = action.payload.meta.total
      state.project.isLoading = true
      break

    case types.GET_TOP_RATED_LIST.FAILED:
      state.project.isLoading = true
      break
    case types.GET_TOTAL_PARTICIPANTS.REQUEST:
      state.totalParticipants = 0
      break
    case types.GET_TOTAL_PARTICIPANTS.SUCCESS:
      state.totalParticipants = action.payload
      break
    case types.GET_TOTAL_PARTICIPANTS.FAILED:
      state.totalParticipants = 0
      break
    case types.GET_POPULAR_SPINS.REQUEST:
      state.popularSpins = []
      break
    case types.GET_POPULAR_SPINS.SUCCESS:
      state.popularSpins = action.payload
      break
    case types.GET_POPULAR_SPINS.FAILED:
      state.popularSpins = []
      break
  }
}, initialState)
